import axios from '@/axios/api.request'

export const list = (path, queryParams) => axios.request({
    url: path,
    data: queryParams,
    method: 'post'
  })
export const remove = (path, id) => axios.request({
    url: `${path}/${id}`,
    method: 'delete'
  })
export const tree = (path) => axios.request({
    url: path,
    method: 'get'
  })
export const download = (path, queryParams) => axios.request({
    url: path,
    data: queryParams,
    method: 'post'
  })

  export const total = (path, queryParams) => axios.request({
    url: path,
    data: queryParams,
    method: 'post'
  })

  export const serialNumber = () => axios.request({
    url: 'order/info/serial',
    method: 'get'
  })